import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ColDef } from 'ag-grid-community';

import { NSEBillConstants } from '@ruby/configs/ebill.constants';
import {
  CategorySummary,
  IEBillCategory,
  IEBillDemrrageCarDetails,
  IEBillDemurrageDetails,
  IEBillDemurrageTypes
} from '@ruby/shared/models/ebill/ebil.interface';

@Component({
  selector: 'ng-ebill-demurrage-component',
  templateUrl: './ebill-demurrage.component.html',
  styleUrls: ['./ebill-demurrage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EBillDemurrageComponent {
  @Input() loading!: boolean;
  @Input() loadingCarDetails!: boolean;
  @Input() demurrageDetails?: IEBillDemurrageDetails;
  @Input() carDetails!: Array<IEBillDemrrageCarDetails>;
  @Output() loadCarDetails = new EventEmitter<IEBillDemurrageTypes>();
  @Output() downloadExcel = new EventEmitter<string>();
  columns: Array<ColDef> = NSEBillConstants.demurrageGridColumns;
  displayedColumns: Array<string> = NSEBillConstants.demurrageSummaryGridColumns;
  categories: Array<IEBillCategory> = [];
  selectedDemurrage!: IEBillDemurrageTypes;
  selectedOption = 'ALL';

  constructor(private location: Location) {}

  /**
   * Selected Index Change
   *
   * @summary selected index change
   * @param $event: number
   * @returns void
   */
  selectedIndexChange($event: number): void {
    const demurrageType: IEBillDemurrageTypes = { ...this.demurrageDetails!.demurrageTypes[$event], billDate: this.demurrageDetails!.billDate };
    this.categories = this.demurrageDetails!.categoryDetails.find((item: CategorySummary) => item.sequenceNumber === demurrageType.value)!.categories;
    this.selectedDemurrage = demurrageType;
    this.loadCarDetails.emit(demurrageType);
  }

  /**
   * Navigate Back
   *
   * @summary return to bill details
   * @return void
   */
  navigateBack(): void {
    this.location.back();
  }
}
